module.exports = __webpack_public_path__ + "img/current-tab.7fa25b93.svg";